import React from 'react'
import PropTypes from 'prop-types'
import { TabsContainer, TabButton } from './styled'

const Tabs = ({ tabs, activeTab, onChange }) => (
	<TabsContainer>
		{tabs.map(tab => (
			<TabButton
				key={tab.id}
				$active={activeTab === tab.id}
				onClick={() => onChange(tab.id)}
			>
				{tab.name}
			</TabButton>
		))}
	</TabsContainer>
)

Tabs.propTypes = {
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			name: PropTypes.string.isRequired
		})
	).isRequired,
	activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onChange: PropTypes.func.isRequired
}

export default Tabs
